import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './back.css';
function ArrowBack({ className, onClick }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        if (onClick) onClick();
        if (!onClick) navigate(-1);
      }}
      className={`arrow_back-btn cursor-pointer font-s${className ? ` ${className}` : ''}`}
    >
      {t('Atrás')}
    </div>
  );
}
export default ArrowBack;
